import styles from "./SetAPIKey.module.css";
import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';

/*
  API Keyを設定するコンポーネント
  - Set API Keyボタン
  - モーダル表示
  - 入力値をAppコンポーネントに返す
*/
const SetAPIKey = ({ apiKey='', onSubmit }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState(apiKey);

  // apiKeyが変化したらinputValueも更新
  React.useEffect(() => {
    setInputValue(apiKey);
  }, [apiKey]);

  const toggleModal = () => setModalOpen(!modalOpen);

  // Submitボタン押下時
  const handleSubmit = () => {
    onSubmit(inputValue); // Appに渡す
    toggleModal();        // モーダルを閉じる
  };

  return (
    <>
      <Button size="sm" outline color="success" className={styles.apiKeyBtn} onClick={toggleModal}>Set API Key</Button>
      <Modal isOpen={modalOpen} toggle={toggleModal} className={styles.modalCentered}>
        <ModalHeader toggle={toggleModal}>Set API Key</ModalHeader>
        <ModalBody>
          <Input
            type="text"
            placeholder="Enter API Key"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>Submit</Button>
          <Button outline onClick={toggleModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SetAPIKey;